import { useMemo } from 'react';

/**
 * Hook para agrupar objetos e somar múltiplos valores numéricos,
 * tratando strings e valores inválidos.
 */
export const useDataAggregation = (data, groupBy, sumKeys = []) => {
  const sumKeysDeps = sumKeys.join(',');

  const aggregatedData = useMemo(() => {
    if (!data || !Array.isArray(data)) return [];

    // Função auxiliar interna para garantir que o valor seja um número válido
    const sanitize = (val) => {
      const num = Number(val);
      return isNaN(num) ? 0 : num;
    };

    return data.reduce((acc, current) => {
      const key = current[groupBy];
      const existing = acc.find(item => item[groupBy] === key);

      if (existing) {
        sumKeys.forEach(sumKey => {
          existing[sumKey] = sanitize(existing[sumKey]) + sanitize(current[sumKey]);
        });
      } else {
        const newItem = { ...current };
        sumKeys.forEach(sumKey => {
          newItem[sumKey] = sanitize(current[sumKey]);
        });
        acc.push(newItem);
      }

      return acc;
    }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, groupBy, sumKeysDeps]); 

  return aggregatedData;
};